import classNames from 'classnames';

import DesktopHeader from './components/desktop-header.component';
import MobileHeader from './components/mobile-header.component';

interface HeaderProps {
  sticky: boolean;
}
const Header = ({ sticky }: HeaderProps) => {
  return (
    <header
      className={classNames({ 'sticky top-0 z-999998 bg-white': sticky })}
    >
      <MobileHeader />
      <DesktopHeader />
    </header>
  );
};

export default Header;
